/**
 * North Macedonian phone numbers as people type them ('071 222 222', '71222222', '+389 71 222 222',
 * '00389 71 222 222') -> E.164 '+38971222222' (what POST /auth/otp/request takes); null when it
 * is not one.
 */
export function normalizeMkPhone(input: string): string | null {
  const compact = input.trim().replace(/[\s\-().\/]/g, '');
  let digits: string;
  if (compact.startsWith('+389')) digits = compact.slice(4);
  else if (compact.startsWith('00389')) digits = compact.slice(5);
  else if (compact.startsWith('389') && compact.length === 11) digits = compact.slice(3);
  else if (compact.startsWith('0')) digits = compact.slice(1);
  else digits = compact;
  if (!/^\d{8}$/.test(digits)) return null;
  return `+389${digits}`;
}

/** '+38971222222' -> '+389 71 222 222' */
export function formatPhone(e164: string): string {
  const m = /^\+389(\d{2})(\d{3})(\d{3})$/.exec(e164);
  return m ? `+389 ${m[1]} ${m[2]} ${m[3]}` : e164;
}
